export function getStatusBadge(status) {
  const colors = {
    pending: "warning",
    audited: "success",
    draft: "dark",
    staged: "info",
    for_audit: "warning",
    "non-vat": "dark-subtle",
  };

  const icon = {
    pending: "clock",
    audited: "check2",
    draft: "file-text",
    staged: "clock",
    for_audit: "clock",
    "non-vat": "file-text",
  };

  function formatStatus(word) {
    if (!word) return "";

    return word
      .split("_")
      .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
      .join(" ");
  }

  return (
    <>
      <div className="col-12 d-flex justify-content-center">
        <div
          className={`bg-${colors[status]} border-${colors[status]} bg-opacity-10 px-2 rounded-5 border d-flex gap-1`}
        >
          <i className={`bi bi-${icon[status]} text-${colors[status]}`}></i>
          <label
            className={`text-${colors[status]} fw-medium`}
            style={{ fontSize: "0.8rem" }}
          >
            {formatStatus(status)}
          </label>
        </div>
      </div>
    </>
  );
}
